export const bankCardLimitChange = {
    enabled: false,
    _description: 'Enables the bank card limit change feature on bank card settings page.',
};
